<template>
  <div class="defaultView">
    <TopMenu page="пользователя" url="/users/upload" @sort="sort" />
    <div class="list">
      <BlockView
        v-for="dates in usersModels"
        :key="dates.id"
        :dates="dates"
        :title="dates.email"
        routeName="users-edit"
      ></BlockView>
    </div>
  </div>
</template>

<script>
import users from "@/composables/views/users.ts";
import BlockView from "@/components/BlockView.vue";
import TopMenu from "@/components/TopMenu.vue";

export default {
  setup() {
    const { login, avatar, email, name, baseUrl, getUsers, usersModels } =
      users();
    return {
      login,
      avatar,
      email,
      name,
      baseUrl,
      getUsers,
      usersModels,
    };
  },
  data() {
    return {
      openPickImage: false,
    };
  },
  components: { BlockView, TopMenu },
  methods: {},
  async created() {
    this.getUsers();
  },
};
</script>
